import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { VOID } from '@frontend-site/shared/utils';
import { Observable, switchMap } from 'rxjs';
import { SystemService } from './system.service';
import { SystemStore } from './system.store';
import { RdxContextStore } from '../rdx/rdx-context.store';
import { RdxContextType } from '../rdx/rdx-context-type.enum';
import { SessionRepository } from '../session';

@Injectable({
    providedIn: 'root'
})
export class SystemDetailsResolver  {
    constructor(
        private store: SystemStore,
        private systemService: SystemService,
        private sessionStore: SessionRepository,
        private rdxContextStore: RdxContextStore
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<void> {
        if (route.params && !route.params['id'] && !route.params['systemId']) {
            return VOID;
        }
        const { systemId } = route.params;
        if (systemId && this.sessionStore.applicationConfig) {
            this.rdxContextStore.updateContext(systemId, RdxContextType.SYSTEM, this.sessionStore.applicationConfig);
        }

        const id = +(route.params['id'] || route.params['systemId']);

        return this.store.systemId === id ? VOID : this.systemService.loadSystemDetails(id).pipe(switchMap(() => VOID));
    }
}
